import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormConfiguration } from "./models/form-config";
import { QuestionBase } from "./models/question-base";
import { QuestionControlService } from "./services/question-control.service";

@Component({
  selector: "app-dynamic-form",
  templateUrl: "./dynamic-form.component.html",
  styleUrls: ["./dynamic-form.component.css"],
  providers: [ QuestionControlService ]
})
export class DynamicFormComponent implements OnInit {
  @Input() inline = false;
  @Input() config: FormConfiguration;
  @Input() questions: QuestionBase[] | null = [];

  @Output() onFormSubmit = new EventEmitter()
  @Output() onFormReset = new EventEmitter()
  colSize = "col-"
  payLoad = "";
  form!: FormGroup;
  isEdit: boolean;

  constructor(
    private qcs: QuestionControlService
  ) {}

    // DA TESTARE
  //@HostListener('document:keyup.enter', ['$event']) onKeydownHandler() {
    //this.onSubmit()
  //}

  ngOnInit() {
    if(this.questions.find(el => el.value ? true : false)){
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase[]);
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.getRawValue());
    this.onFormSubmit.emit(this.form.getRawValue())
  }

  onBtnEvent(btnType: string, event: Event) {
    if(btnType === 'reset' && this.isEdit === true) {
      event.preventDefault();
      console.log(event)
      this.onFormReset.emit();
      this.form = this.qcs.toFormGroup(this.questions as QuestionBase[]);
    }
    else if(btnType === 'reset' && this.isEdit === false) {
      this.form.reset()
      this.onFormReset.emit(this.form.getRawValue())
    }
  }

  retrieveEvent(event:string){
    this.onSubmit();
  }
}
